async function r(e){return new Promise(n=>{setTimeout(n,e)})}export{r as a};
//# sourceMappingURL=chunk-3JPVQHOR.mjs.map